'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.setLanguage = setLanguage;
exports.setFallbackLanguage = setFallbackLanguage;
exports.setTranslations = setTranslations;
exports.setForceRefresh = setForceRefresh;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function setLanguage(lang) {
  return {
    type: 'REDUX_I18N_SET_LANGUAGE',
    lang: lang
  };
}

function setFallbackLanguage(newFallbackLang) {
  return {
    type: 'REDUX_I18N_SET_FALLBACK_LANGUAGE',
    newFallbackLang: newFallbackLang
  };
}

function updateTranslations(translations) {
  return {
    type: 'REDUX_I18N_SET_TRANSLATIONS',
    translations: translations
  };
}

function setTranslations(translations, languageOrOptions) {
  return function (dispatch, getState) {
    var options = typeof languageOrOptions === 'string' ? {
      language: languageOrOptions
    } : languageOrOptions || {};
    var language = options.language,
        preserveExisting = options.preserveExisting;
    var state = getState();
    var trans = null;

    if (state.i18nState === undefined) {
      trans = state.getIn(['i18nState', 'translations']);
    } else {
      trans = _extends({}, state.i18nState.translations);
    }

    var newTranslations = language === undefined ? translations : _extends({}, trans, _defineProperty({}, language, translations));
    dispatch(updateTranslations(preserveExisting ? Object.keys(newTranslations).reduce(function (allTranslations, lang) {
      return _extends({}, allTranslations, _defineProperty({}, lang, _extends({}, allTranslations[lang], newTranslations[lang])));
    }, trans) : newTranslations));
    dispatch(setForceRefresh(true));
  };
}

function setForceRefresh(force) {
  return {
    type: 'REDUX_I18N_SET_FORCE_REFRESH',
    force: force
  };
}